/**
* Created by ctsi-biyi-generator
*/
export default {
'zh-CN': {
'tqtEpinfomation.id.label': '',
'tqtEpinfomation.id.holder': '请输入',
'tqtEpinfomation.id.max': '最多11个字符',
'tqtEpinfomation.id.required': '必填',
'tqtEpinfomation.searchId.holder': '搜索',
'tqtEpinfomation.adminId.label': '',
'tqtEpinfomation.adminId.holder': '请输入',
'tqtEpinfomation.adminId.max': '最多11个字符',
'tqtEpinfomation.adminId.required': '必填',
'tqtEpinfomation.searchAdminId.holder': '搜索',
'tqtEpinfomation.theme.label': '主题',
'tqtEpinfomation.theme.holder': '请输入主题',
'tqtEpinfomation.theme.max': '主题最多54个字符',
'tqtEpinfomation.theme.required': '主题必填',
'tqtEpinfomation.searchTheme.holder': '搜索主题',
'tqtEpinfomation.content.label': '内容',
'tqtEpinfomation.content.holder': '请输入内容',
'tqtEpinfomation.content.max': '内容最多1,028个字符',
'tqtEpinfomation.content.required': '内容必填',
'tqtEpinfomation.searchContent.holder': '搜索内容',
'tqtEpinfomation.fileAddress.label': '文件',
'tqtEpinfomation.fileAddress.holder': '请输入文件',
'tqtEpinfomation.fileAddress.max': '文件最多255个字符',
'tqtEpinfomation.fileAddress.required': '文件必填',
'tqtEpinfomation.searchFileAddress.holder': '搜索文件',
'tqtEpinfomation.createTime.label': '',
'tqtEpinfomation.createTime.holder': '请输入',
'tqtEpinfomation.createTime.max': '最多null个字符',
'tqtEpinfomation.createTime.required': '必填',
'tqtEpinfomation.searchCreateTime.holder': '搜索',
'tqtEpinfomation.updateTime.label': '',
'tqtEpinfomation.updateTime.holder': '请输入',
'tqtEpinfomation.updateTime.max': '最多null个字符',
'tqtEpinfomation.updateTime.required': '必填',
'tqtEpinfomation.searchUpdateTime.holder': '搜索',
},
'zh-TW': {
'tqtEpinfomation.id.label': '',
'tqtEpinfomation.id.holder': '請輸入',
'tqtEpinfomation.id.max': '最多11個字符',
'tqtEpinfomation.id.required': '必填',
'tqtEpinfomation.searchId.holder': '搜索',
'tqtEpinfomation.adminId.label': '',
'tqtEpinfomation.adminId.holder': '請輸入',
'tqtEpinfomation.adminId.max': '最多11個字符',
'tqtEpinfomation.adminId.required': '必填',
'tqtEpinfomation.searchAdminId.holder': '搜索',
'tqtEpinfomation.theme.label': '主题',
'tqtEpinfomation.theme.holder': '請輸入主题',
'tqtEpinfomation.theme.max': '主题最多54個字符',
'tqtEpinfomation.theme.required': '主题必填',
'tqtEpinfomation.searchTheme.holder': '搜索主题',
'tqtEpinfomation.content.label': '内容',
'tqtEpinfomation.content.holder': '請輸入内容',
'tqtEpinfomation.content.max': '内容最多1,028個字符',
'tqtEpinfomation.content.required': '内容必填',
'tqtEpinfomation.searchContent.holder': '搜索内容',
'tqtEpinfomation.fileAddress.label': '文件',
'tqtEpinfomation.fileAddress.holder': '請輸入文件',
'tqtEpinfomation.fileAddress.max': '文件最多255個字符',
'tqtEpinfomation.fileAddress.required': '文件必填',
'tqtEpinfomation.searchFileAddress.holder': '搜索文件',
'tqtEpinfomation.createTime.label': '',
'tqtEpinfomation.createTime.holder': '請輸入',
'tqtEpinfomation.createTime.max': '最多null個字符',
'tqtEpinfomation.createTime.required': '必填',
'tqtEpinfomation.searchCreateTime.holder': '搜索',
'tqtEpinfomation.updateTime.label': '',
'tqtEpinfomation.updateTime.holder': '請輸入',
'tqtEpinfomation.updateTime.max': '最多null個字符',
'tqtEpinfomation.updateTime.required': '必填',
'tqtEpinfomation.searchUpdateTime.holder': '搜索',
},
'en-US': {
'tqtEpinfomation.id.label': '',
'tqtEpinfomation.id.holder': 'Enter ',
'tqtEpinfomation.id.max': ' max length: 11',
'tqtEpinfomation.id.required': ' required',
'tqtEpinfomation.searchId.holder': 'Search ',
'tqtEpinfomation.adminId.label': '',
'tqtEpinfomation.adminId.holder': 'Enter ',
'tqtEpinfomation.adminId.max': ' max length: 11',
'tqtEpinfomation.adminId.required': ' required',
'tqtEpinfomation.searchAdminId.holder': 'Search ',
'tqtEpinfomation.theme.label': '主题',
'tqtEpinfomation.theme.holder': 'Enter 主题',
'tqtEpinfomation.theme.max': '主题 max length: 54',
'tqtEpinfomation.theme.required': '主题 required',
'tqtEpinfomation.searchTheme.holder': 'Search 主题',
'tqtEpinfomation.content.label': '内容',
'tqtEpinfomation.content.holder': 'Enter 内容',
'tqtEpinfomation.content.max': '内容 max length: 1,028',
'tqtEpinfomation.content.required': '内容 required',
'tqtEpinfomation.searchContent.holder': 'Search 内容',
'tqtEpinfomation.fileAddress.label': '文件',
'tqtEpinfomation.fileAddress.holder': 'Enter 文件',
'tqtEpinfomation.fileAddress.max': '文件 max length: 255',
'tqtEpinfomation.fileAddress.required': '文件 required',
'tqtEpinfomation.searchFileAddress.holder': 'Search 文件',
'tqtEpinfomation.createTime.label': '',
'tqtEpinfomation.createTime.holder': 'Enter ',
'tqtEpinfomation.createTime.max': ' max length: null',
'tqtEpinfomation.createTime.required': ' required',
'tqtEpinfomation.searchCreateTime.holder': 'Search ',
'tqtEpinfomation.updateTime.label': '',
'tqtEpinfomation.updateTime.holder': 'Enter ',
'tqtEpinfomation.updateTime.max': ' max length: null',
'tqtEpinfomation.updateTime.required': ' required',
'tqtEpinfomation.searchUpdateTime.holder': 'Search ',
}
};